import { render, staticRenderFns } from "./writtenAi.vue?vue&type=template&id=066ed2e9&scoped=true&"
import script from "./writtenAi.vue?vue&type=script&lang=js&"
export * from "./writtenAi.vue?vue&type=script&lang=js&"
import style0 from "./writtenAi.vue?vue&type=style&index=0&id=066ed2e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ed2e9",
  null
  
)

export default component.exports